import { useMemo } from 'react';
import { ProfileRow, ProfileSection, ProfileSections } from '../../components/ProfileSection';
import { sortByStartDate } from '../../helpers';

interface Props {
    data: any[] | undefined;
};

export default function Education({ data }: Props) {
    const degrees = useMemo(() => sortByStartDate(data), [data]);

    return (
        <ProfileSections>
            {data && data.length === 0 && <span>No education experience.</span>}

            {degrees?.map((item, index) => <ProfileSection key={index} title={`Degree ${index + 1}`}>
                <ProfileRow wide label='School  or university'>{item.universityName}</ProfileRow>
                <ProfileRow wide label='Degree'>{item.degree}</ProfileRow>
                <ProfileRow wide label='Field of study'>{item.field}</ProfileRow>
                <ProfileRow wide label='Overal result (GPA)'>{item.GPA}</ProfileRow>
                <ProfileRow wide label='Date'>{item.from} - {item.to || 'Present'}</ProfileRow>
            </ProfileSection>)}
        </ProfileSections>
    );
};
